module.exports = __webpack_public_path__ + "img/hello_card_front_last_4_digits.3bbb6dea.png";